"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var sanitize_exports = {};
__export(sanitize_exports, {
  maxOpenApiDepth: () => maxOpenApiDepth,
  maxOpenApiNodes: () => maxOpenApiNodes,
  openApiProseKeys: () => openApiProseKeys,
  openApiUrlKeys: () => openApiUrlKeys,
  sanitizeOpenApiSpec: () => sanitizeOpenApiSpec,
  sanitizeUrl: () => sanitizeUrl,
  stripEmbeddedContent: () => stripEmbeddedContent
});
module.exports = __toCommonJS(sanitize_exports);
const maxOpenApiDepth = 100;
const maxOpenApiNodes = 2e5;
const forbiddenKeys = /* @__PURE__ */ new Set(["__proto__", "constructor", "prototype"]);
const openApiUrlKeys = /* @__PURE__ */ new Set([
  "url",
  "termsOfService",
  "externalValue",
  "openIdConnectUrl",
  "authorizationUrl",
  "tokenUrl",
  "refreshUrl"
]);
const openApiProseKeys = /* @__PURE__ */ new Set(["description", "summary"]);
function sanitizeOpenApiSpec(value) {
  const walk = {
    nodes: 0,
    overflow: false,
    externalRefs: /* @__PURE__ */ new Set(),
    rejectedUrls: /* @__PURE__ */ new Set(),
    strippedEmbeds: 0,
    cycles: 0
  };
  const sanitized = sanitizeValue(value, 0, /* @__PURE__ */ new Set(), walk);
  return {
    spec: isRecord(sanitized) ? sanitized : {},
    report: {
      externalRefs: [...walk.externalRefs].sort((a, b) => a.localeCompare(b)),
      rejectedUrls: [...walk.rejectedUrls].sort((a, b) => a.localeCompare(b)),
      strippedEmbeds: walk.strippedEmbeds,
      cycles: walk.cycles
    },
    overflow: walk.overflow
  };
}
__name(sanitizeOpenApiSpec, "sanitizeOpenApiSpec");
function sanitizeValue(value, depth, ancestors, walk) {
  if (walk.nodes >= maxOpenApiNodes) {
    walk.overflow = true;
    return void 0;
  }
  walk.nodes++;
  if (value === null) return null;
  switch (typeof value) {
    case "string":
      return value;
    case "number":
      return Number.isFinite(value) ? value : void 0;
    case "boolean":
      return value;
    case "object":
      break;
    default:
      return void 0;
  }
  if (depth >= maxOpenApiDepth) {
    walk.overflow = true;
    return void 0;
  }
  const object = value;
  if (ancestors.has(object)) {
    walk.cycles++;
    return {};
  }
  ancestors.add(object);
  try {
    if (Array.isArray(value)) {
      const items = [];
      for (const item of value) {
        const sanitized = sanitizeValue(item, depth + 1, ancestors, walk);
        if (sanitized !== void 0) items.push(sanitized);
      }
      return items;
    }
    if (!isPlainish(object)) {
      return void 0;
    }
    return sanitizeObject(value, depth, ancestors, walk);
  } finally {
    ancestors.delete(object);
  }
}
__name(sanitizeValue, "sanitizeValue");
function sanitizeObject(value, depth, ancestors, walk) {
  const ref = Reflect.get(value, "$ref");
  if (typeof ref === "string" && !ref.startsWith("#")) {
    walk.externalRefs.add(ref);
    return { description: stripEmbeddedContent(`External reference not shown: ${ref}`) };
  }
  const result = {};
  for (const key of Object.keys(value)) {
    if (forbiddenKeys.has(key)) continue;
    const raw = Reflect.get(value, key);
    if (typeof raw === "string") {
      if (openApiUrlKeys.has(key)) {
        const url = sanitizeUrl(raw);
        if (url === void 0) {
          walk.rejectedUrls.add(raw);
          continue;
        }
        result[key] = url;
        continue;
      }
      if (openApiProseKeys.has(key)) {
        const prose = stripEmbeddedContent(raw);
        if (prose !== raw) walk.strippedEmbeds++;
        result[key] = prose;
        continue;
      }
    }
    const sanitized = sanitizeValue(raw, depth + 1, ancestors, walk);
    if (sanitized !== void 0) result[key] = sanitized;
  }
  return result;
}
__name(sanitizeObject, "sanitizeObject");
function sanitizeUrl(value) {
  const trimmed = value.trim();
  if (trimmed === "") return value;
  const scheme = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(trimmed)?.[1];
  if (scheme === void 0) return value;
  const lower = scheme.toLowerCase();
  return lower === "http" || lower === "https" ? value : void 0;
}
__name(sanitizeUrl, "sanitizeUrl");
const htmlTag = /<\/?[a-zA-Z][^>]*>/g;
const markdownImage = /!\[/g;
function stripEmbeddedContent(text) {
  return text.replace(markdownImage, "[").replace(htmlTag, "");
}
__name(stripEmbeddedContent, "stripEmbeddedContent");
function isRecord(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
__name(isRecord, "isRecord");
function isPlainish(value) {
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}
__name(isPlainish, "isPlainish");
//# sourceMappingURL=sanitize.js.map
